module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_4.08359ccf.png";